import { isLocalEnvironment } from "$routes/_lib/environment";
import { Box, styled } from "@material-ui/core";
import { useSearchParams } from "react-router-dom";
import { ScenarioPicker } from "./_lib/components/scenario-picker";
import { useAgentUrl } from "./_lib/dev-agent-url";
import { DEFAULT_SCENARIO_ID } from "./_lib/mock-script";
import { OnboardingConversation } from "./_lib/onboarding-conversation";

const PageRoot = styled(Box)({
  height: "100%",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
});

export const EpocusOnboardingPage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const scenarioId = searchParams.get("scenario") ?? DEFAULT_SCENARIO_ID;
  const usingMock = !useAgentUrl();

  return (
    <PageRoot>
      {usingMock && isLocalEnvironment() && (
        <ScenarioPicker
          scenarioId={scenarioId}
          onChange={(next) => setSearchParams({ scenario: next })}
        />
      )}
      <OnboardingConversation key={scenarioId} scenarioId={scenarioId} />
    </PageRoot>
  );
};
